import { cn } from "@/lib/utils";
import { CheckIcon, XIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

export default function FeaturesSection() {
  const features = [
    "Amount of Verified Leads",
    "No Need for Separate Email Verification",
    "Discounted Additional Credits",
    "Money–Back Guarantee",
    "Never Pay for the Same Lead Twice",
    "Unlimited Users",
    "No Charge for Invalid Emails",
    "Visualize Smart Insights About Your ICP",
    "Priority Support",
    "Price",
  ];

  const data = [
    ["710M", "275M", "174M", "150M"],
    [true, false, false, false],
    [true, false, false, false],
    ["30 Days", false, false, false],
    ["Lifetime", false, false, false],
    [true, false, false, false],
    [true, false, false, false],
    [true, false, false, false],
    [true, false, false, false],
    ["$97", "$99", "$399+", "$70"],
  ];

  const companies = [
    {
      icon: (
        <Image
          src="/images/listkit-logo.webp"
          alt="Listkit Logo"
          width={415}
          height={120}
          className="h-[28px] w-[97px]"
        />
      ),
    },
    {
      icon: (
        <Image
          src="/images/apollo-logo.webp"
          alt="Apollo Logo"
          width={193}
          height={48}
          className="h-[24px] w-[96px]"
        />
      ),
    },
    {
      icon: (
        <Image
          src="/images/zoominfo-logo.webp"
          alt="Zoominfo Logo"
          width={415}
          height={120}
          className="h-[22px] w-[128px]"
        />
      ),
    },
    {
      icon: (
        <Image
          src="/images/lusha-logo.webp"
          alt="Lusha Logo"
          width={415}
          height={120}
          className="h-[30px] w-[102px]"
        />
      ),
    },
  ];

  return (
    <section id="features-section">
      <div className="flex justify-center w-full px-[18px] lg:px-18">
        <div className="flex overflow-x-auto flex-col items-center justify-center w-full max-w-[1220px] gap-14">
          <div className="flex flex-col items-center text-lg lg:text-4xl tracking-tight leading-[22px] lg:leading-[42px] font-semibold">
            <p className="text-[#0D2A4C]">
              Unlock Seamless Communication Explore
            </p>
            <Link
              className="text-[#2A8DFF] underline"
              href="https://www.listkit.io/phone-numbers.html"
            >
              Our Exclusive Phone-Only Plans Here!
            </Link>
          </div>
          <h1 className="text-[#0D2A4C] lg:pt-10 lg:pb-5 tracking-tighter text-center text-[32px] lg:text-[56px] leading-[37px] lg:leading-14 max-w-[300px] lg:max-w-[485px] font-semibold">
            How We Stack Up (It’s Not Even Close)
          </h1>
          <div className="overflow-x-auto w-full">
            <table className="min-w-[1000px]">
              <thead>
                <tr className="lg:h-[70px] h-[60px] border-b border-[#0D2A4C0D]">
                  <th className="text-[#0D2A4C] text-start w-[390px] lg:px-9 border-r border-[#0D2A4C0D] tracking-tighter lg:text-2xl lg:leading-6 font-semibold">
                    Features
                  </th>
                  {companies.map((company, i) => (
                    <th
                      key={i}
                      className={cn(
                        "border-r w-[235px] border-[#0D2A4C0D]",
                        i === 0 && "bg-[#F8F9FA]"
                      )}
                    >
                      <div className="w-full flex justify-center">
                        {company.icon}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {features.map((feature, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className="border-b last:border-b-0 border-[#0D2A4C0D]  h-[60px] lg:h-[70px]"
                  >
                    <td className="text-[#0D2A4C99] w-[390px] lg:px-9 tracking-tight font-medium lg:text-[16px] lg:leading-4 border-r last:border-r-0 border-[#0D2A4C0D]">
                      {feature}
                    </td>
                    {data[rowIndex].map((value, colIndex) => (
                      <td
                        key={colIndex}
                        className={cn(
                          "text-center w-[235px] align-middle border-r last:border-r-0 border-[#0D2A4C0D]",
                          colIndex === 0 && "bg-[#F8F9FA]",
                          colIndex === 0 &&
                            rowIndex === features.length - 1 &&
                            "bg-[#2A8DFF]"
                        )}
                      >
                        {value === true && (
                          <div className="flex justify-center">
                            <CheckIcon className="text-[#16A34A] size-6" />
                          </div>
                        )}
                        {value === false && (
                          <div className="flex justify-center">
                            <XIcon className="text-[#DC2626] size-6" />
                          </div>
                        )}
                        <p
                          className={cn(
                            "text-[#0D2A4C] border-r border-[#0D2A4C0D] tracking-tighter lg:text-2xl lg:leading-6 font-semibold",
                            colIndex === 0 &&
                              rowIndex === features.length - 1 &&
                              "text-white"
                          )}
                        >
                          {value}
                        </p>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
